import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";
import { getCookie } from "../../../api/utils/utils";

export type OrderProduct = {
  product_id: number;
  quantity: number;
  variant_id: number;
};

export type CreateOrderPayload = {
  products: OrderProduct[];
  site_pay:number;
};

export type CreateOrderResponse = {
  status: boolean;
  message: string;
  res?: {
    status: boolean;
    redirect_url?: string;
  };
  data?: {
    id: number;
    order_code: string;
    total_price: string;
    total_quantity: number;
    user_id: number;
    status_id: number;
    provider: string;
    procurement_status: string;
    created_at: string;
  };
};

export class BasketProvider {
  static async getAllBasket() {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.get(url, {
      headers: { "Accept-Language": "az" },
    });
  }
  static async postAddBasket(payload: {
    product_id: number;
    quantity: number;
    variant_id?: number;
  }) {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.post(url, payload, {
      headers: { "Accept-Language": "az" },
    });
  }
  static async createOrder(payload: CreateOrderPayload) {
    return await $axios.post($api("create_order"), payload, {
      headers: { "Accept-Language": "az" },
    });
  }
  static async putBasket(payload: {
    product_id: number;
    quantity: number;
    variant_id?: number;
  }) {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.put(url, payload, {
      headers: { "Accept-Language": "az" },
    });
  }
  static async deleteBasket(productId: number, variantId?: number) {
    const guestToken = getCookie("x-guest-token");
    const params: Record<string, any> = { id: productId };
    if (variantId !== undefined && variantId !== null) {
      params.variant_id = variantId;
    }
    if (guestToken) {
      params.guest_token = guestToken;
    }
    const url = $api("remove_basket", params);
    return await $axios.delete(url, {
      headers: { "Accept-Language": "az" },
    });
  }
  static async clearBasket() {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.delete(url, {
      headers: { "Accept-Language": "az" },
    });
  }
  static async getTotalBasket() {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("total_basket", { guest_token: guestToken })
      : $api("total_basket");
    return await $axios.get(url, {
      headers: { "Accept-Language": "az" },
    });
  }
  static async getFilials() {
    return await $axios.get($api("get_filials"));
  }

  static async postQuickOrder(payload: {
    product_id: number;
    name: string;
    phone: string;
  }) {
    return await $axios.post($api("post_quick_order"), payload);
  }
}
